// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  margin-top: 150px;
}

li {
  list-style: none !important;
}`, "",{"version":3,"sources":["webpack://./src/Layout/Footer/footer.module.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ;;AAEA;EACI,2BAAA;AACJ","sourcesContent":["\nfooter{\n    margin-top: 150px;\n}\nli{\n    list-style: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
